import { createContext, useContext } from 'react'

// Provides a boolean flag indicating that the Finance Marketplace is being previewed by a Pro
// (via the "Test" button in the Share popover). When true, descendants must disable any UI that
// would submit or redirect to a real finance application so Pros don't accidentally apply on
// behalf of their customer.
export const PreviewModeContext = createContext<boolean>(false)

export const usePreviewMode = (): boolean => useContext(PreviewModeContext)

// True when the Finance Marketplace is shown on the standalone shared-link page (not embedded in MyEnergy).
export const StandaloneModeContext = createContext<boolean>(false)

export const useStandaloneMode = (): boolean => useContext(StandaloneModeContext)
